var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.cmpTestimonialsImage'] = (function () {
    'use strict';

    const initialize = (widget) => {

        const carouselEl = widget.querySelector(".splide");
        if (!carouselEl) return;

        let splideOptions = { pagination: false };
        const slideEls = carouselEl?.querySelectorAll(".splide__slide");

        if (slideEls.length < 2) {
            splideOptions = { ...splideOptions, perPage: 1 };
        }
        else {
            splideOptions = {
                ...splideOptions,
                perPage: 2,
                breakpoints: {
                    1199: {
                        perPage: 1
                    },
                    767: {
                        perPage: 1,
                        padding: { right: '4rem' }
                    },
                }
            };
        }

        App.Helpers.splideFallback(
            carouselEl,
            splideOptions,
            function (splide) {
                splide.on('overflow', function (isOverflow) {
                    splide.options = {
                        arrows: isOverflow,
                        drag: isOverflow,
                        perPage: isOverflow ? splide.options.perPage : splide.length
                    };
                });
            }
        );
    }

    return {
        initialize
    };

})();